<script lang="ts">
  let { children, class: className = "", contentClass = "", title = "", subtitle = "", hoverEffect = true } = $props();
</script>

<div class="glass-card flex flex-col {hoverEffect ? 'hover:border-primary/20 hover:shadow-primary/5 hover:-translate-y-0.5' : ''} {className}">
  {#if title || subtitle}
    <div class="px-6 py-4 border-b border-base-content/5 bg-base-content/[0.02]">
      {#if title}
        <h3 class="text-sm font-bold tracking-tight text-base-content/90">{title}</h3>
      {/if}
      {#if subtitle}
        <p class="text-[11px] text-base-content/60 font-medium uppercase tracking-wider mt-0.5">{subtitle}</p>
      {/if}
    </div>
  {/if}
  <div class="flex-1 {contentClass ? contentClass : 'p-6'}">
    {@render children()}
  </div>
</div>
